import apiClient from './apiClient';
import logger from '../core/logger/logger';

// ===== AUTH API =====
export const authAPI = {
  // Авторизация через Telegram (правильный эндпоинт)
  loginWithTelegram: async (telegramUser) => {
    const response = await apiClient.post('/v1/auth/telegram', telegramUser);
    return response.data;
  },

  // Обновление токена
  refreshToken: async (refreshToken) => {
    const response = await apiClient.post('/v1/auth/refresh', { refreshToken });
    return response.data;
  },

  // Получить профиль пользователя
  getProfile: async () => {
    const response = await apiClient.get('/auth/profile');
    return response.data;
  }
};

// ===== USER API =====
export const userAPI = {
  // Получить данные пользователя (используем auth/profile)
  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/profile');
    return response.data;
  },

  // Получить баланс пользователя (правильный эндпоинт)
  getBalance: async () => {
    const response = await apiClient.get('/wallet/balance');
    return response.data;
  },

  // Завершить онбординг пользователя
  completeOnboarding: async () => {
    const response = await apiClient.patch('/v1/users/onboarding');
    return response.data;
  },

  // TON кошелёк
  getTonWallet: async () => {
    const response = await apiClient.get('/v1/users/wallet/ton');
    return response.data;
  },

  saveTonWallet: async (address) => {
    const response = await apiClient.post('/v1/users/wallet/ton', { address });
    return response.data;
  },

  unlinkTonWallet: async () => {
    const response = await apiClient.delete('/v1/users/wallet/ton');
    return response.data;
  },
};

// ===== LUCKY SPIN API =====
export const luckySpinAPI = {
  // Крутить рулетку (правильный формат запроса)
  spin: async (boostId = null) => {
    const response = await apiClient.post('/v1/lucky-spin/spin', {
      boostId
    });
    return response.data;
  },

  // Получить доступные награды
  getRewards: async (rewardSet = 'base') => {
    const response = await apiClient.get(`/v1/lucky-spin/rewards?rewardSet=${rewardSet}`);
    return response.data;
  },

  // Получить прогресс пользователя
  getProgress: async () => {
    const response = await apiClient.get('/v1/lucky-spin/progress');
    return response.data;
  },

  // Забрать накопленную награду за этап прогресса (без claimId — самую старую)
  // → { claimedReward: {id, stage, spinsRequired, type, value, displayName}, progress }
  claimProgressReward: async (claimId = null) => {
    const response = await apiClient.post('/v1/lucky-spin/progress/claim', claimId ? { claimId } : {});
    return response.data;
  },

  // Получить все этапы
  getAllStages: async () => {
    const response = await apiClient.get('/lucky-spin/stages');
    return response.data;
  }
};

// ===== TASKS API (legacy) =====
export const tasksAPI = {
  getTasks: async () => {
    const response = await apiClient.get('/v1/tasks');
    return response.data;
  },
  completeTask: async (taskId) => {
    await apiClient.post(`/v1/tasks/${taskId}/complete`);
  },
  claimTask: async (taskId) => {
    const response = await apiClient.post(`/v1/tasks/${taskId}/claim`);
    return response.data;
  },
};

// ===== ACHIEVEMENTS API =====
export const achievementsAPI = {
  getAchievements: async () => {
    const response = await apiClient.get('/v1/achievements');
    return response.data;
  },
  claimAchievement: async (userAchievementId) => {
    const response = await apiClient.post(`/v1/achievements/${userAchievementId}/claim`);
    return response.data;
  },
  // Проверка подписки на канал игры (getChatMember на бэке) → { subscribed }
  verifyChannelSubscription: async () => {
    const response = await apiClient.post('/v1/achievements/channel-subscription/verify');
    return response.data;
  },
};

// ===== NOTIFICATIONS API =====
export const notificationsAPI = {
  getNotifications: async () => {
    const response = await apiClient.get('/v1/notifications');
    return response.data; // { tasks, inventory, network, shop, battlePass }
  },
};

// ===== INVENTORY API =====
export const inventoryAPI = {
  // Получить модули пользователя по типу (или все, если тип не указан)
  getModules: async (type = null) => {
    const url = type ? `/inventory/modules?type=${type}` : '/inventory/modules';
    const response = await apiClient.get(url);
    return response.data;
  },

  // Получить все модули пользователя
  getAllModules: async () => {
    return inventoryAPI.getModules();
  },

  // Получить модули головы
  getHeadModules: async () => {
    return inventoryAPI.getModules('HEAD');
  },

  // Получить модули тела
  getBodyModules: async () => {
    return inventoryAPI.getModules('BODY');
  },

  // Получить модули рук
  getHandModules: async () => {
    return inventoryAPI.getModules('HAND');
  },

  // Получить модули ног
  getLegModules: async () => {
    return inventoryAPI.getModules('LEG');
  },

  // Отметить модули как просмотренные
  markModulesAsViewed: async (moduleIds) => {
    const response = await apiClient.post('/inventory/modules/mark-viewed', { moduleIds });
    return response.data;
  },

  // Отметить один модуль как просмотренный
  markModuleAsViewed: async (moduleId) => {
    const response = await apiClient.post(`/inventory/modules/mark-as-viewed/${moduleId}`);
    return response.data;
  }
};

// ===== SHOP API =====
export const shopAPI = {
  // Получить товары магазина
  getGoods: async (type = null) => {
    const url = type ? `/v1/shop?type=${type}` : '/v1/shop';
    const response = await apiClient.get(url);
    return response.data;
  },

  // Оплатить товар Stars (XTR) - возвращает invoice link для openInvoice()
  purchaseWithStars: async ({ purchaseType = 'SHOP', itemId, quantity = 1 }) => {
    const response = await apiClient.post('/v1/payments/purchase', {
      purchaseType,
      itemId,
      currency: 'XTR',
      paymentMethod: 'TELEGRAM',
      quantity,
    });
    return response.data; // { invoiceLink, success }
  },

  // Инициализировать TON Connect платеж (возвращает данные для транзакции)
  initTonConnectPayment: async ({ purchaseType = 'SHOP', itemId, description, quantity = 1 }) => {
    const response = await apiClient.post('/payments/ton-connect/init', {
      purchaseType,
      itemId,
      description,
      quantity,
    });
    return response.data; // { purchaseId, walletAddress, amount, amountNanotons, message, comment, payload }
  },

  // Получить товар Boost Ticket (скрытый из магазина)
  getBoostTicketItem: async () => {
    const response = await apiClient.get('/v1/shop/boost-ticket');
    return response.data;
  },

  // Получить пакеты AutoCollect (скрыты из общего магазина)
  getAutoCollectItems: async () => {
    const response = await apiClient.get('/v1/shop/auto-collect');
    return response.data;
  },

  // Проверить TON транзакцию и завершить покупку
  verifyTonTransaction: async (purchaseId, transactionHash, fromAddress) => {
    const response = await apiClient.post('/payments/ton-connect/verify', {
      purchaseId,
      transactionHash,
      fromAddress,
    });
    return response.data; // { success, pending, message?, error? } — pending = transfer not seen on-chain yet
  },

  // Получить историю покупок (пока заглушка)
  getPurchaseHistory: async () => {
    // TODO: Реализовать в бэкенде
    throw new Error('Shop API not implemented yet');
  },

  // Получить бусты
  getBoosts: async () => {
    const response = await apiClient.get('/v1/shop/boosts');
    return response.data;
  },

  // Получить паки (ShopPack)
  getPacks: async () => {
    logger.debug('Getting shop packs');
    const response = await apiClient.get('/v1/shop/packs');
    return response.data;
  },

  // Статус бесплатного получения товара
  getFreeClaimStatus: async (itemId) => {
    const response = await apiClient.get(`/v1/shop/items/${itemId}/free-claim/status`);
    return response.data;
  },

  // Бесплатно получить товар
  claimFreeItem: async (itemId) => {
    const response = await apiClient.post(`/v1/shop/items/${itemId}/free-claim`);
    return response.data;
  },
};

// ===== WALLET API =====
export const walletAPI = {
  // Получить баланс кошелька
  getBalance: async () => {
    const response = await apiClient.get('/v1/wallet/balance');
    // Backend returns: { coins, tonCoins, tickets, boostTickets } (PlayerBalanceDTO)
    // Map to Redux wallet state field names
    return {
      datumCoins: response.data.coins || 0,
      ton: response.data.tonCoins || 0,
      tickets: response.data.tickets || 0,
      boostTickets: response.data.boostTickets ?? 0,
    };
  },

  // Конвертировать валюту (пока заглушка)
  exchangeCurrency: async (amount, fromCurrency, toCurrency) => {
    // TODO: Создать контроллер для обмена валют в бэкенде
    throw new Error('Exchange API not implemented yet');
  },

  // Получить историю транзакций (пока заглушка)
  getTransactionHistory: async (limit = 50) => {
    // TODO: Реализовать в бэкенде
    throw new Error('Transaction history API not implemented yet');
  }
};

// ===== STREAK API =====
// ПРИМЕЧАНИЕ: В бэкенде нет контроллера для streak наград, нужно создать
export const streakAPI = {
  // Проверить доступные награды (пока заглушка)
  checkStreakBonuses: async () => {
    // TODO: Создать контроллер для streak наград в бэкенде
    return {
      receivedRewards: [],
      availableRewards: []
    };
  },

  // Получить награду за streak (пока заглушка)
  claimStreakReward: async (rewardId) => {
    // TODO: Реализовать в бэкенде
    throw new Error('Streak API not implemented yet');
  }
};

// ===== SOCIAL API =====
export const socialAPI = {
  // Получить список приглашённых друзей (реальный эндпоинт)
  getFriends: async () => {
    const response = await apiClient.get('/v1/users/referrals');
    return response.data;
  },

  getLeaderboard: async (limit = 50) => {
    const response = await apiClient.get(`/v1/leaderboard?limit=${limit}`);
    return response.data;
  },

  // Пригласить друга (пока заглушка)
  inviteFriend: async (telegramId) => {
    // TODO: Реализовать в бэкенде
    throw new Error('Social API not implemented yet');
  },

  // Получить реферальную ссылку (пока заглушка)
  getReferralLink: async () => {
    // TODO: Реализовать в бэкенде
    throw new Error('Social API not implemented yet');
  },

  // Получить 1 ticket за конкретного приглашённого (однократно)
  claimReferralTicket: async (referralId) => {
    const response = await apiClient.post(`/v1/users/referrals/${referralId}/claim-ticket`);
    return response.data;
  }
};

// ===== DAILY REWARDS API =====
export const dailyRewardsAPI = {
  // Получить информацию о стрике пользователя
  getStreakInfo: async () => {
    logger.debug('Getting daily rewards streak info');
    const response = await apiClient.get('/v1/daily-rewards/streak');
    return response.data;
  },

  // Получить ежедневную награду
  claimReward: async () => {
    logger.debug('Claiming daily reward');
    const response = await apiClient.post('/v1/daily-rewards/claim');
    return response.data;
  }
};

// ===== TICKETS API =====
export const ticketsAPI = {
  // Получить статус сбора тикетов
  getStatus: async () => {
    logger.debug('Getting ticket collection status');
    const response = await apiClient.get('/v1/tickets/status');
    return response.data;
  },

  // Забрать бесплатный тикет вручную
  claimTicket: async () => {
    logger.debug('Claiming free ticket');
    const response = await apiClient.post('/v1/tickets/claim');
    return response.data;
  },

  // Получить курс обмена монет на тикеты
  getExchangeRate: async () => {
    logger.debug('Getting coin-to-ticket exchange rate');
    const response = await apiClient.get('/v1/tickets/exchange-rate');
    return response.data;
  },

  // Конвертировать монеты в тикеты
  convert: async (tickets) => {
    logger.debug('Converting coins to tickets', { tickets });
    const response = await apiClient.post('/v1/tickets/convert', { tickets });
    return response.data;
  },

  // Включить/выключить авто-сбор тикетов
  setAutoCollect: async (enabled) => {
    const response = await apiClient.patch('/v1/tickets/auto-collect', { enabled });
    return response.data;
  },
};

// ===== CHARACTER API =====
export const characterAPI = {
  getCharacters: async () => {
    const response = await apiClient.get('/characters');
    return response.data;
  },

  // { price, owned } — 100 coins for the first hero, ×2 for each next one
  getSlotPrice: async () => {
    const response = await apiClient.get('/characters/slot-price');
    return response.data;
  },

  purchaseSlot: async () => {
    const response = await apiClient.post('/characters/purchase-slot');
    return response.data;
  },

  // rank — merge rank of the inventory stack (v1.39.0); the part already in the slot goes back to inventory
  equipModule: async (characterId, moduleId, rank = 0) => {
    const response = await apiClient.put(`/characters/${characterId}/equip-module`, { moduleId, rank });
    return response.data;
  },

  unequipModule: async (characterId, slotType) => {
    const response = await apiClient.delete(`/characters/${characterId}/slots/${slotType}`);
    return response.data;
  },

  // Locks the assembly; afterwards the hero can be sent on missions
  completeCharacter: async (characterId) => {
    const response = await apiClient.post(`/characters/${characterId}/complete`);
    return response.data;
  }
};

// ===== MODULE RANKS / MERGE (alchemy) =====
export const mergeAPI = {
  getRanks: async () => {
    const response = await apiClient.get('/v1/modules/ranks');
    return response.data;
  }
};

// ===== IDLE MERGE BOARD (v1.43.0) =====
// rule violations (422) are shown by the board as a soft hint, not as a global alert
const SILENT = { silentError: true };
// 10×10 board: drag a part onto a part of the same body type (any hero) — the target keeps its look,
// stats are summed. Every call returns the whole board {width, height, cells[{x, y, item}], rules, merged}.
export const mergeBoardAPI = {
  getBoard: async () => (await apiClient.get('/v1/merge-board')).data,
  // inventory copy → cell (toX/toY omitted = first free cell)
  place: async (moduleId, rank, toX, toY) =>
    (await apiClient.post('/v1/merge-board/place', { moduleId, rank, toX, toY }, SILENT)).data,
  move: async (fromX, fromY, toX, toY) =>
    (await apiClient.post('/v1/merge-board/move', { fromX, fromY, toX, toY }, SILENT)).data,
  // source = board cell {fromX, fromY} or inventory copy {moduleId, rank}
  merge: async (source, toX, toY) =>
    (await apiClient.post('/v1/merge-board/merge', { ...source, toX, toY }, SILENT)).data,
  take: async (fromX, fromY) => (await apiClient.post('/v1/merge-board/take', { fromX, fromY }, SILENT)).data,
  fill: async () => (await apiClient.post('/v1/merge-board/fill', null, SILENT)).data,
  collect: async () => (await apiClient.post('/v1/merge-board/collect', null, SILENT)).data,
  // v1.45.0 — Merge Board 2.0: unlock a locked cell next to an open one (coins), claim a whole fragment
  buyCell: async (x, y) => (await apiClient.post('/v1/merge-board/buy-cell', { x, y }, SILENT)).data,
  claim: async (fromX, fromY) => (await apiClient.post('/v1/merge-board/claim', { fromX, fromY }, SILENT)).data,
};

// ===== DATUM PASS API =====
export const datumPassAPI = {
  getProduct: async () => {
    const response = await apiClient.get('/v1/datum-pass/product');
    return response.data;
  },
  getStatus: async () => {
    const response = await apiClient.get('/v1/datum-pass/status');
    return response.data;
  },
  // COINS only — the balance is debited server-side. TON / Stars go through shopAPI
  // (purchaseWithStars / initTonConnectPayment) with purchaseType 'DATUM_PASS' and are
  // activated by the backend after the provider confirms the payment.
  purchaseWithCoins: async ({ productId, idempotencyKey }) => {
    const headers = idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {};
    const response = await apiClient.post(
      '/v1/datum-pass/purchase',
      { productId, paymentCurrency: 'COINS' },
      { headers }
    );
    return response.data;
  },
};

// ===== BATTLE PASS API =====
export const battlePassAPI = {
  getBattlePass: async () => {
    const response = await apiClient.get('/v1/battle-pass');
    return response.data;
  },
  claimTier: async (tierId, track, idempotencyKey) => {
    const headers = idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {};
    const response = await apiClient.post(
      `/v1/battle-pass/tiers/${tierId}/claim`,
      { track },
      { headers }
    );
    return response.data;
  },
};

// ===== LOOTBOX API =====
export const lootboxAPI = {
  getChestTypes: async () => {
    const response = await apiClient.get('/v1/lootbox/chest-types');
    return response.data;
  },
  getKeyTypes: async () => {
    const response = await apiClient.get('/v1/lootbox/key-types');
    return response.data;
  },
  getInventory: async () => {
    const response = await apiClient.get('/v1/lootbox/inventory');
    return response.data;
  },
  openChest: async (chestTypeId, idempotencyKey) => {
    const headers = idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {};
    const response = await apiClient.post(
      `/v1/lootbox/chests/${chestTypeId}/open`,
      {},
      { headers }
    );
    return response.data;
  },
  getChestContents: async (chestTypeId) => {
    const response = await apiClient.get(`/v1/lootbox/chest-types/${chestTypeId}/contents`);
    return response.data;
  },
  // Possible rewards of every active chest in one request: [{ chestTypeId, contents: [...] }]
  getAllChestContents: async () => {
    const response = await apiClient.get('/v1/lootbox/contents');
    return response.data;
  },
};

// ===== AFFILIATE API =====
export const affiliateAPI = {
  getConfigs: async (eventType) => {
    const response = await apiClient.get(`/v1/affiliate/configs?eventType=${eventType}`);
    return response.data;
  },
  getMyEarnings: async () => {
    const response = await apiClient.get('/v1/affiliate/my-earnings');
    return response.data;
  },
  getPartnership: async () => {
    const response = await apiClient.get('/v1/affiliate/partnership');
    return response.data;
  },
};

// ===== AD REWARDS API (AdsGram) =====
export const adRewardsAPI = {
  // Step 1: register pending reward before showing AdsGram ad
  // targetId (v1.47.0): HERO_REST → character id, LAIR_FARM → building id
  initiate: async (rewardType, shopItemId = null, targetId = null) => {
    const response = await apiClient.post('/v1/ad-rewards/initiate', { rewardType, shopItemId, targetId });
    return response.data; // { adEventId }
  },

  // Poll after ad completes to check if webhook already delivered the reward
  getStatus: async (adEventId) => {
    const response = await apiClient.get(`/v1/ad-rewards/${adEventId}/status`);
    return response.data; // { adEventId, status, rewardType }
  },

  // Availability of the rewarded-ad free ticket — shared cooldown for Shop & LuckySpin
  getFreeTicketStatus: async () => {
    const response = await apiClient.get('/v1/ad-rewards/free-ticket/status');
    return response.data; // { isAvailable, nextAvailableTime, cooldownMinutes }
  },
};

// ===== TON WITHDRAWAL API =====
export const tonWithdrawalAPI = {
  createRequest: async (amount) => {
    const response = await apiClient.post('/v1/ton-withdrawal/request', { amount });
    return response.data;
  },

  getRequests: async () => {
    const response = await apiClient.get('/v1/ton-withdrawal/requests');
    return response.data;
  },

  getTonTransactions: async () => {
    const response = await apiClient.get('/v1/ton-withdrawal/ton-transactions');
    return response.data;
  },

  cancelRequest: async (requestId) => {
    const response = await apiClient.post(`/v1/ton-withdrawal/requests/${requestId}/cancel`);
    return response.data;
  },
};

// ===== LEGAL API (v1.48.0) =====
// Privacy policy / offer / affiliate terms: the consent window is shown while status.allAccepted === false
export const legalAPI = {
  getStatus: async () => (await apiClient.get('/v1/legal/status')).data,
  getDocument: async (id) => (await apiClient.get(`/v1/legal/documents/${id}`)).data,
  accept: async (documentIds) => (await apiClient.post('/v1/legal/accept', { documentIds })).data,
};

// Экспортируем все API методы
export default {
  auth: authAPI,
  user: userAPI,
  luckySpin: luckySpinAPI,
  tasks: tasksAPI,
  inventory: inventoryAPI,
  shop: shopAPI,
  wallet: walletAPI,
  streak: streakAPI,
  social: socialAPI,
  dailyRewards: dailyRewardsAPI,
  tickets: ticketsAPI,
  character: characterAPI,
  merge: mergeAPI,
  mergeBoard: mergeBoardAPI,
  datumPass: datumPassAPI,
  battlePass: battlePassAPI,
  lootbox: lootboxAPI,
  affiliate: affiliateAPI,
  tonWithdrawal: tonWithdrawalAPI,
  adRewards: adRewardsAPI,
  legal: legalAPI,
};

